import axios from 'axios';

export const newsletter = (email: string): Promise<void> =>
  axios.post('/api/newsletter', { email });
